<script>
import NameBubble from '../../../components/name-bubble.vue';

export default {
    props: {
        users: {
            type: Object,
            required: true
        },

        title: {
            type: String,
            requireD: true
        },
    },

    components: {
        NameBubble
    },
}
</script>

<template>
    <div class="assigned-users">
        <div class="assigned-user-type">
            {{ title }}
        </div>

        <div class="flex-all-centered-row" style="justify-content: flex-start; align-items: center;">
            <div v-for="user in users" :key="user.user_id">
                <name-bubble 
                    :Words="user.name.split(' ')" 
                    :XonHover="false" 
                    :Radius="40"
                    :PutEmphasis="true" 
                    v-sust-tooltip="{
                        text: user.name
                    }"
                />
            </div>
        </div>

        <div v-if="!users || users.length === 0">
            {{ $t('metric_discussions.no_assignmets_text') }}
        </div>
    </div>
</template>

<style lang='scss' scoped>
    .assigned-users {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        > .assigned-user-type {
            font-weight: bold;
            font-size: 1.2em;
            margin-bottom: .5em;
        }
    }
</style>